import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import chiefLogo from '../../assets/img/brand/Report-footer.png'
import carrosoieLogo from '../../assets/img/brand/carrosserie-spiez.png'
import sws_ag from '../../assets/img/brand/sws-ag.png'
import headersecondlogo from '../../assets/header-second-img.png'
import "../newReportPrintPDF.css";
import "./ReportHeaderFooter.css";
class ReportHeader_Swiss extends Component {
  state = {
    words: {},
    lang: "Gb",
    data: "",
    insurenceProviderInfo: [],
    fallbackInfo: {},
    jsonData: {},
    InsurenceName: "",
    customerCompany: ""
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  async componentDidMount() {
    const client = localStorage.getItem("client")
    await this._getData();
    await this.getFallbackDetails();
    await this.getInsuranceName();
    this.getLang();
    await this.getInsurenceClients();
    client === "SWISS" || client === "POLAND" && this.getCustomerCompany();
  }

  getCustomerCompany = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let url = configuration.getSingleQRDetails + "?partnerId=" + partnerId + "&vin=" + vin + "&qr_type=" + 1
    Axios.get(url)
      .then((res) => {
        if (res.data.data.length && res.data.data[0].hasOwnProperty('customerCompany')) {
          this.setState({
            customerCompany: (res.data.data[0].customerCompany).toLowerCase()
          })
        }
      })
      .catch((err) => console.log(err))
  }

  getFallbackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    const res = await Axios.get(url);
    let fallback_data = {};
    if (res.data.success !== false) {
      let company_logo =
        configuration.getFallbackLogoPath +
        localStorage.getItem("partnerId") +
        "/" +
        res.data.company_logo;
      fallback_data = {
        Logo: res.data.company_logo
          ? company_logo
          : require("../../assets/img/brand/Adi.png"),
        Email: res.data.company_email || "sales@adi-gmbh.com",
        CompanyName: res.data.company_name || "Auto Damage Inspection GmbH",
        Website: res.data.company_website || "https://adi-gmbh.com",
        Address: res.data.company_address || "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: res.data.primary_color || "#FF0000",
        SecondaryColor: res.data.secondary_color || "#000000",
        PrimaryContact: res.data.contact_number || "08954809487",
        RegisterNo: res.data.company_registration_number || "HRB1234",
      };
    } else {
      fallback_data = {
        Logo: require("../../assets/img/brand/Adi.png"),
        Email: "sales@adi-gmbh.com",
        CompanyName: "Auto Damage Inspection GmbH",
        Website: "https://adi-gmbh.com",
        Address: "Kreuzstr 81, 85716 Unterschleißheim, Germany.",
        PrimaryColor: "#FF0000",
        SecondaryColor: "#000000",
        PrimaryContact: "08954809487",
        RegisterNo: "HRB1234",
      };
    }
    this.setState({ fallbackInfo: fallback_data });
  };

  getInsuranceName = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile").split("_")[0];
    const { jsonData } = this.state
    if (jsonData.hasOwnProperty('InsurenceName') && jsonData.InsurenceName !== "") {
      localStorage.setItem("InsurenceName", jsonData.InsurenceName)
      this.setState({
        InsurenceName: jsonData.InsurenceName
      })
    } else if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
        "?partnerId=" +
        partnerId +
        "&vin=" +
        vin
      );
      if (res.data.length) {
        localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
        this.setState({
          InsurenceName: res.data[0].InsurenceName
        })
      } else {
        localStorage.setItem("InsurenceName", "");
      }
    } else {
      localStorage.setItem("InsurenceName", "");
    }
  };

  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");
    // let InsurenceName = localStorage.getItem("InsurenceName");
    const { InsurenceName } = this.state
    if (InsurenceName === 'null') {
      InsurenceName = null;
    }
    if (InsurenceName && partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      Axios.get(url).then((res) => {
        if (res.data) {
          let insurenceProviderInfo;
          res.data.map((data, index) => {
            if (insurenceProviderInfo && insurenceProviderInfo.Logo) {
              data.Logo = `${configuration.imagePath}/scanImages/${partnerId}/insurenceClients/${insurenceProviderInfo.Logo}`;
            } 
          });
          if (insurenceProviderInfo && insurenceProviderInfo.Logo) {
            insurenceProviderInfo.Logo = `${configuration.imagePath}/scanImages/${partnerId}/insurenceClients/${insurenceProviderInfo.Logo}`;
          }
          this.setState({ insurenceProviderInfo: insurenceProviderInfo });
        } else {
          this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
        }
      });
    } else {
      this.setState({ insurenceProviderInfo: this.state.fallbackInfo });
    }
  };

  _getData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        this.setState({ data: r.data.Datetime, jsonData: r.data });
      }
    });
  };

  _onImageError = () => {
    const partnerId = localStorage.getItem("partnerId");
    let insurenceProviderInfo = this.state.insurenceProviderInfo;
    insurenceProviderInfo.Logo = require("../../assets/img/brand/logo.png");
    this.setState({ insurenceProviderInfo: insurenceProviderInfo });
  };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    const { customerCompany } = this.state
    return (
      <>
        <div>
          <div className="container-fluid p-0 top-header-pdf us_report_header">
            <div className="row p-0 new-report-header-row d-flex align-items-end">
              <div
                className="col-lg-6 custom-col first-Border h-100"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                {/* {((client === "SWISS" || client === "POLAND" && customerCompany === "carrosserie spiez ag") || partnerId === '19-spiez') ?
                  <img
                    onError={() => this._onImageError()}
                    src="demo.png"
                  />
                  : */}
                  <div className="header-logo-img">
                    <img
                      onError={() => this._onImageError()}
                      src={`${this.state.fallbackInfo.Logo}`}
                    />
                    <div className="linear-header-white-box"></div>
                  </div>
                {/* } */}
              </div>
              <div className="col-6 custom-col second-border">
                <div className="header-second-logo">
                  <img src={headersecondlogo} />
                </div>
                <div className="header-text">
                  <h6 className="header-title">{this.lang("VIN")}<span>:</span> <span className="header-span-value"> {localStorage.getItem("selectedFile")} </span></h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(ReportHeader_Swiss);
